import React, { useState } from 'react';
import { CalendarCheckIcon, CheckIcon, PackageIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { equipment, facilities, facilitySlots, pickupWindows } from '../../data/loisirs';
import { BookingDialog, type BookingTarget } from './BookingDialog';
export function BookingServices() {
  const [target, setTarget] = useState<BookingTarget | null>(null);
  const [booked, setBooked] = useState<Record<string, string>>({});
  return <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:gap-10" data-id="element-1933" data-mp="2pafhk0hiw8ng">
      <section aria-labelledby="espaces-titre" data-id="element-1934" data-mp="2td3pm5yexbjd">
        <h2 id="espaces-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1935" data-mp="2tbsm878vq5ss">
          Réserver un espace
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1936" data-mp="2kce01jzqwhe3">Salles, gymnases, terrains et patinoires.</p>

        <p className="mt-4 flex items-start gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm text-ville-navy" data-id="element-1937" data-mp="13y5oekgijsh8">
          <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1938" data-mp="18zv2ya2y2oa2" />
          « Je cherche une salle pour 20 personnes samedi après-midi. » — voici les espaces proposés par ATNA.
        </p>

        <ul className="mt-4 space-y-3" data-id="element-1939" data-mp="3k58x1s6560e2">
          {facilities.map(facility => {
          const slots = facilitySlots.filter(slot => slot.facilityId === facility.id).length;
          const confirmation = booked[facility.id];
          return <li key={facility.id} className="rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1940" data-mp="ax67rpp6ie5h">
                <div className="flex flex-wrap items-center gap-4" data-id="element-1941" data-mp="6vuo00szkn57">
                  <div className="min-w-0 flex-1" data-id="element-1942" data-mp="kokccbvzm45h">
                    <h3 className="font-bold text-ville-navy" data-id="element-1943" data-mp="kn9707mw8oc9">{facility.name}</h3>
                    <p className="mt-0.5 text-sm text-slate-500" data-id="element-1944" data-mp="fq94u7t605qf">
                      {facility.place} · {slots} créneaux libres
                    </p>
                    <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1945" data-mp="pnds6ayqy78t">
                      <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-1946" data-mp="wqby38xp3k6i" />
                      {facility.capacity}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-1947" data-mp="11pybpjhfr2fu">
                    <p className="font-extrabold text-ville-navy" data-id="element-1948" data-mp="16orkwzpow7a7">{facility.price}</p>
                    <button type="button" onClick={() => setTarget({
                  kind: 'espace',
                  facility
                })} className="mt-2 rounded-full bg-ville-navy px-4 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1949" data-mp="1bf828uwmsd1u">
                      {confirmation ? 'Réserver de nouveau' : 'Réserver'}
                    </button>
                  </div>
                </div>

                {confirmation && <p className="mt-3 flex items-start gap-2 rounded-xl bg-ville-mist px-4 py-3 text-[13px] font-semibold text-ville-deep" data-id="element-1950" data-mp="3w4xhva55s2vl">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-1951" data-mp="3onhgazj04ug4" />
                    Réservé — {confirmation}
                  </p>}
              </li>;
        })}
        </ul>

        <p className="mt-3 flex items-center gap-2 text-xs text-slate-500" data-id="element-1952" data-mp="3ets3rn029ftc">
          <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1953" data-mp="39yuy8q1zpol7" />
          Une fois confirmée, la réservation est ajoutée à votre carte numérique et la facture à Mon profil.
        </p>
      </section>

      <section aria-labelledby="equipement-titre" data-id="element-1954" data-mp="6e8h56twavn9">
        <h2 id="equipement-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1955" data-mp="1gfakcoojzmg">
          Louer de l’équipement
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1956" data-mp="3spm5nm2f34wy">Équipement sportif et matériel communautaire.</p>

        <ul className="mt-4 space-y-3" data-id="element-1957" data-mp="2m5cw5lj9dzs1">
          {equipment.map(item => {
          const windows = pickupWindows.filter(window => window.equipmentId === item.id).length;
          const confirmation = booked[item.id];
          return <li key={item.id} className="rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1958" data-mp="eoxqa85w0nc7">
                <div className="flex flex-wrap items-center gap-4" data-id="element-1959" data-mp="17ph67frxc">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy" aria-hidden="true" data-id="element-1960" data-mp="4xtax7cav0gu">
                    <PackageIcon className="h-5 w-5" data-id="element-1961" data-mp="xmgp6iymspkw" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-1962" data-mp="xke1i5kyb8jc">
                    <h3 className="font-bold text-ville-navy" data-id="element-1963" data-mp="iog1udbtjm2d">{item.name}</h3>
                    <p className="text-sm text-slate-500" data-id="element-1964" data-mp="no18l9x8cypn">
                      {item.detail} · {windows} plages de cueillette
                    </p>
                  </div>
                  <div className="text-right" data-id="element-1965" data-mp="38erznuqord1n">
                    <p className="font-extrabold text-ville-navy" data-id="element-1966" data-mp="38fkz0anbf09r">{item.price}</p>
                    <button type="button" onClick={() => setTarget({
                  kind: 'equipement',
                  equipment: item
                })} className="mt-2 rounded-full border border-ville-navy px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1967" data-mp="1qgdi0z4zfrm0">
                      {confirmation ? 'Réserver de nouveau' : 'Réserver'}
                    </button>
                  </div>
                </div>

                {confirmation && <p className="mt-3 flex items-start gap-2 rounded-xl bg-ville-mist px-4 py-3 text-[13px] font-semibold text-ville-deep" data-id="element-1968" data-mp="1gktrks96tl4n">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-1969" data-mp="o1wgvqd260ye" />
                    Cueillette réservée — {confirmation}
                  </p>}
              </li>;
        })}
        </ul>

        <p className="mt-3 text-xs text-slate-500" data-id="element-1970" data-mp="2j5ks7j0e3rv0">
          Présentez votre carte numérique au moment de la cueillette.
        </p>
      </section>

      <BookingDialog target={target} onClose={() => setTarget(null)} onBooked={(id, summary) => setBooked(current => ({
      ...current,
      [id]: summary
    }))} data-id="element-1971" data-mp="2sv4d0u7nxvsi" />
    </div>;
}